module.exports = __webpack_public_path__ + "static/img/bdm_rank1.706e19e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bdm/bdm_rank1.png
// module id = KCW5
// module chunks = 0